import { SectionProvider } from "./Components/utils/SectionContext/SectionContext";
import Home from "./Home/Home";

function App() {
  return (
    <>
      <div id="app">
        <SectionProvider>
          <Home />
        </SectionProvider>
      </div>
    </>
  );
}

export default App;
